import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class Policy extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "sort", Model.attribute('sort'));
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "url", Model.attribute('url'));
    _defineProperty(this, "updateMessage", Model.attribute('updateMessage'));
    _defineProperty(this, "termsUpdatedAt", Model.attribute('termsUpdatedAt'));
    _defineProperty(this, "optional", Model.attribute('optional'));
    _defineProperty(this, "additionalInfo", Model.attribute('additionalInfo'));
    _defineProperty(this, "form_key", computed('id', id => 'fof_terms_policy_' + id));
  }
}
flarum.reg.add('fof-terms', 'common/models/Policy', Policy);